import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";

const Login = lazy(() => import("./modules/Auth/Login"));
const Signup = lazy(() => import("./modules/Auth/Signup"));
const AdminDashboard = lazy(() => import("./modules/Admin/AdminDashboard"));
const StudentDashboard = lazy(() => import("./modules/Student/StudentDashboard"));
const UserProfile = lazy(() => import("./modules/Common/UserProfile"));
const LandingPage = lazy(() => import("./modules/Public/LandingPage"));

const PageLoader = () => (
  <div className="h-screen flex items-center justify-center font-bold text-gray-500">
    Please wait...
  </div>
);

function AppRoutes() {
  const { user, userData, loading } = useAuth();

  if (loading) return <div className="h-screen flex items-center justify-center font-bold text-gray-500">Loading Portal...</div>;

  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={
            user ? (
                userData?.role === "admin" ? <Navigate to="/admin" /> : <Navigate to="/student" />
            ) : (
                <LandingPage />
            )
        } />

        <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
        <Route path="/signup" element={!user ? <Signup /> : <Navigate to="/" />} />

        <Route path="/admin" element={
          user && userData?.role === "admin" ? <AdminDashboard /> : <Navigate to="/" />
        } />
        
        <Route path="/student" element={
          user && userData?.role === "student" ? <StudentDashboard /> : <Navigate to="/" />
        } />
        
        <Route path="/profile" element={user ? <UserProfile /> : <Navigate to="/" />} />
        <Route path="/user/:username" element={user ? <UserProfile /> : <Navigate to="/" />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Suspense>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <AppRoutes />
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
      }
                                       
